import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export default function PageTitle({ children }: Props) {
  return (
    <h1 className="break-words text-4xl leading-10 md:text-5xl md:leading-14 bg-clip-text bg-gradient-to-r font-extrabold from-pink-600 to-sky-600 dark:from-pink-400 dark:to-sky-400 h1 leading-tighter text-center text-transparent tracking-tighter selection:text-gray-800 dark:selection:text-gray-200">
      {children}
    </h1>
  )
}
